// ─── Types ────────────────────────────────────────────────────────────────────
export interface MediaItem {
  id:          string;
  uuid:        string;
  imageSrc:    string;
  title:       string;
  alt:         string; // ✅ add
  size:        string;
  isVideo?:    boolean;
  mediaType:   string;
  status:      'active' | 'deactive' | 'draft';
  uploadBy:    string;
  uploadDate:  string;
  description: string;
}

export interface SelectOption {
  value: string;
  label: string;
}

// ─── Media Items ──────────────────────────────────────────────────────────────

export const MEDIA_ITEMS: MediaItem[] = [
  {
    id:          "01",
    uuid:        "",
      alt:         "",      
    imageSrc:    "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=600&q=80",
    title:       "Career.jpg",
    size:        "12 MB",
    isVideo:     false,
    mediaType:   "image",
    status:      "active",
    uploadBy:    "Admin",
    uploadDate:  "01 August, 2025",
    description: "",
  },
  {
    id:          "02",
    uuid:        "",
      alt:         "",      
    imageSrc:    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&q=80",
    title:       "Herosector.mp4",
    size:        "12 MB",
    isVideo:     true,
    mediaType:   "video",
    status:      "active",
    uploadBy:    "Admin",
    uploadDate:  "01 August, 2025",
    description: "",
  },
  {
    id:          "03",
    uuid:        "",
      alt:         "",      
    imageSrc:    "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=600&q=80",
    title:       "Untittle1.jpg",
    size:        "12 MB",
    isVideo:     false,
    mediaType:   "image",
    status:      "active",
    uploadBy:    "Admin",
    uploadDate:  "01 August, 2025",
    description: "",
  },
  {
    id:          "04",
    uuid:        "",
      alt:         "",      
    imageSrc:    "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&q=80",
    title:       "Untittle2.jpg",
    size:        "12 MB",
    isVideo:     false,
    mediaType:   "image",
    status:      "active",
    uploadBy:    "Admin",
    uploadDate:  "01 August, 2025",
    description: "",
  },
  {
    id:          "05",
    uuid:        "",
      alt:         "",      
    imageSrc:    "https://images.unsplash.com/photo-1512428813834-c702c7702b78?w=600&q=80",
    title:       "Untittle3.jpg",
    size:        "12 MB",
    isVideo:     false,
    mediaType:   "image",
    status:      "active",
    uploadBy:    "Admin",
    uploadDate:  "01 August, 2025",
    description: "",
  },
  {
    id:          "06",
    uuid:        "",
      alt:         "",      
    imageSrc:    "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=600&q=80",
    title:       "Untittle4.jpg",
    size:        "12 MB",
    isVideo:     false,
    mediaType:   "image",
    status:      "deactive",
    uploadBy:    "Admin",
    uploadDate:  "01 August, 2025",
    description: "",
  },
  {
    id:          "07",
    uuid:        "",
      alt:         "",      
    imageSrc:    "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=600&q=80",
    title:       "Untittle5.jpg",
    size:        "12 MB",
    isVideo:     false,
    mediaType:   "image",
    status:      "draft",
    uploadBy:    "Admin",
    uploadDate:  "01 August, 2025",
    description: "",
  },
];

// ─── Filter Options ───────────────────────────────────────────────────────────

export const MEDIA_TYPE_OPTIONS: SelectOption[] = [
  { value: "all-media", label: "All media" },
  { value: "image",     label: "Image"     },
  { value: "video",     label: "Video"     },
];

export const STATUS_OPTIONS: SelectOption[] = [
  { value: "all-status", label: "All status" },
  { value: "active",     label: "Active"     },
  { value: "deactive",   label: "Deactive"   },
  { value: "draft",      label: "Draft"      },
];

// ─── Table Config ─────────────────────────────────────────────────────────────

export const MEDIA_TABLE_COLUMNS = [
  "ID",
  "File name",
  "Type",
  "Size",
  "Upload by",
  "Upload date",
  "Status",
  "Action",
];

export const MEDIA_TABLE_COLUMN_WIDTHS: Record<string, string> = {
  ID:            "6%",
  "File name":   "24%",
  Type:          "9%",
  Size:          "9%",
  "Upload by":   "10%",
  "Upload date": "16%",
  Status:        "17%",
  Action:        "9%",
};